import bdapi from "@bd-core/bd-api";
import bdjs from "@bd-core/bdjs";
import $ from "jquery";

export const LoginPage = () => {
    const isLoginPage = $("#login-page").length > 0;
    if (!isLoginPage) return false;

    const $elms = {
        loginPage: $("#login-page"),
        loginComponent: $("#simple-login"),
        loginBtn: $("#login-btn"),
        loginEmail: $("#login-email"),
        loginState: $("#login-state"),
        ssoLoginBtn: $("#sso-login-btn"),
    };

    const classes = {
        inputError: "simple-auth__input--error",
        error: "simple-auth__error",
        input: "simple-auth__input",
    };

    /**
     * Validates email format
     *
     * @param {string} email - Email address to validate
     * @returns {boolean} - True if email is valid
     */
    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    /**
     * Shows error message for a form field
     *
     * @param {any} $field - The input field element (jQuery object)
     * @param {string} message - Error message to display
     */
    const showFieldError = ($field, message) => {
        $field.addClass(classes.inputError);
        let $errorMsg = $field.siblings(`.${classes.error}`);
        if ($errorMsg.length === 0) {
            $errorMsg = $("<span>").addClass(classes.error);
            $field.after($errorMsg);
        }
        $errorMsg.text(message).show();
    };

    /**
     * Removes error message from a form field
     *
     * @param {any} $field - The input field element (jQuery object)
     */
    const clearFieldError = ($field) => {
        $field.removeClass(classes.inputError);
        $field.siblings(`.${classes.error}`).hide();
    };

    /**
     * Validates login form
     *
     * @returns {boolean} - True if validation passes
     */
    const validateLoginForm = () => {
        const email = $elms.loginEmail.val().trim();

        let isValid = true;

        clearFieldError($elms.loginEmail);

        if (!email) {
            showFieldError($elms.loginEmail, "Email is required");
            isValid = false;
        } else if (!isValidEmail(email)) {
            showFieldError(
                $elms.loginEmail,
                "Please enter a valid email address",
            );
            isValid = false;
        }

        return isValid;
    };

    $elms.loginComponent.on("input", `.${classes.input}`, function () {
        clearFieldError($(this));
    });

    $elms.loginBtn.on("click", (e) => {
        e.preventDefault();

        if (!validateLoginForm()) {
            return;
        }

        const email = $elms.loginEmail.val().trim();
        const state = $elms.loginState.val();

        bdjs.goAsync(
            bdapi
                .post("public/login", {
                    email: email,
                    state: state,
                })
                .then((response) => {
                    if (response.data.success) {
                        window.location.href = "/intro" + response.data.data.state;
                    }
                }),
        );
    });

    $elms.ssoLoginBtn.on("click", (e) => {
        e.preventDefault();
        const $this = $(e.currentTarget);
        const loginUrl = $this.data("login-url");
        window.location.href = loginUrl;
        return false;
    });
};
